// extracted by css-extract-rspack-plugin
export default {"container":"container-y6xa17"};